import { TextBalanceStyle } from "./style";
import { ContextProviderWrapper } from "../../Context";
import { useContext } from "react";

export default function TextBalance({
  balance,
  isImage,
  listChains,
  chain,
}: any) {
  const { theme } = useContext(ContextProviderWrapper)!;
  return (
    <TextBalanceStyle className={theme}>
      <h1>{balance}</h1>
      {isImage && (
        <div className="img-s">
          <img
            src={listChains?.find((item: any) => item.name === chain)?.logoUrl}
            alt="iconS"
          />
        </div>
      )}
    </TextBalanceStyle>
  );
}
